<template>
  <div>
    <div class="relative">
      <!-- Background Image -->
      <img
        :src="img"
        alt="Background Image"
        class="w-full h-[600px] sm:h-[800px] object-cover"
      />

      <!-- Centered Text -->
      <div
        :class="[
          'absolute inset-0 flex flex-col items-center text-center text-white px-6',
          isUpper ? 'justify-start mt-[177px]' : 'justify-center',
        ]"
      >
        <h1 class="text-[24px] md:text-[32px] lg:text-[40px] font-bold mb-4">
          {{ title }}
        </h1>
        <p class="text-[16px] lg:text-[24px] max-w-xl leading-relaxed">
          {{ detailed }}
        </p>
        <a
          href="/services"
          :class="[
            'px-4 py-2 md:px-[87px] text-sm md:py-[16px] rounded-[60px] bg-tbt-blue mt-[20px] font-bold',
            isVisible ? 'block' : 'hidden',
          ]"
        >
          {{ getLocalized1("btn") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: { type: String, required: true },
    detailed: { type: String, required: true },
    title: { type: String, required: true },
    isUpper: { type: Boolean, default: false }, // Set default to false if not provided
    isVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      translations: {
        btn: {
          en: "Explore More",
          kh: "ស្វែងយល់បន្ថែម",
        },
      },

      // Default language is from localStorage or 'en' if not set
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    getLocalized1() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },
};
</script>
